import { SearchPanel } from '@/components/search-panel';
import { ArticleResults } from '@/components/article-results';
import { useArticleSearch } from '@/lib/use-article-search';

export function SearchPage() {
  const articleSearch = useArticleSearch();

  return (
    <div className="container-wide pb-6 sm:pb-8">
      <div className="md:sticky md:top-14 z-30 -mx-4 px-4 bg-(--color-brand-sage) py-4 mb-4 border-b border-(--color-border)">
        <SearchPanel />
      </div>

      <ArticleResults {...articleSearch} />
    </div>
  );
}
